<template>
  <!-- <button
    type="button"
    class="btn btn-primary"
    data-bs-toggle="modal"
    data-bs-target="#exampleModal"
    @click="updateBar"
  >
    Launch demo modal
  </button> -->

  <div
    class="modal fade"
    ref="bar"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="static"
  >
    <!-- id="exampleModal" -->
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center" style="font-size: 22px">
          <div class="progress" style="height: 25px">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              :style="{ width: percentage + '%' }"
              aria-valuenow="10"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ percentage + "%" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { computed, onMounted, watch } from "@vue/runtime-core";
import { Modal } from "bootstrap";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const bar = ref();
    const percentage = ref(0);

    //gettters
    const isShow = computed(() => store.getters["commonLoadingBar/get_isShow"]);

    //bar的控制器初始化
    let controller = ref();
    onMounted(() => {
      controller.value = new Modal(bar.value, {});
    });
    watch(controller,
      (newValue) => {
        //確保Modal已經開啟(newValue._isShown == true)
        if (newValue._isShown == true && isShow.value == true) {
          //設定開啟值
          setShowBarVal();
        } else if (newValue._isShown == true && isShow.value == false) {
          //設定關閉Modal和值
          setHideBarVal();
          controller.value.hide();
        }
      },
      { deep: true }
    );


    //設定開啟Loading Bar的變數
    let timeout = null;
    const setShowBarVal = () => {
      percentage.value = 30;
      clearInterval(timeout);
      timeout = setInterval(() => {
        if (percentage.value >= 90) {
          return;
        }
        percentage.value += 30;
      }, 700);
    };

    //設定關閉Loading Bar的變數
    const setHideBarVal = () => {
      percentage.value = 100;
      clearInterval(timeout);
    };

    // watch 是否開啟modal
    watch(isShow, (newValue) => {
      if (newValue == true) {
        controller.value.show(); //modal開啟
      } else {
        controller.value.hide(); //modal關閉
      }
    });

    

    return {
      bar,
      percentage,
    };
  },
};
</script>

<style>
</style>